module.exports = __webpack_public_path__ + "static/media/Add.4796fdc8.svg";